import { useState } from 'react';
import { Moon, Sun } from 'lucide-react';
import { getMode, toggleMode } from '../lib/theme';
import { t } from '../lib/i18n';

// Light/dark switch. Flipping toggleMode() rewrites data-pm-mode on <html>, so
// every var(--pm-*) surface repaints via CSS; this button only re-renders its icon.
export default function ModeToggle() {
  const [mode, setMode] = useState(getMode());
  return (
    <button
      type="button"
      onClick={() => setMode(toggleMode())}
      title={mode === 'dark' ? t('Light mode') : t('Dark mode')}
      aria-label={t('Toggle dark mode')}
      className="rounded-md p-2 text-pm-muted hover:bg-pm-raised hover:text-pm-text"
    >
      {mode === 'dark' ? <Sun size={16} aria-hidden /> : <Moon size={16} aria-hidden />}
    </button>
  );
}
